<template>
  <div class="fullNav">
    <div class="fullNav-warp">
      <ul style="display: flex; flex-direction: column">
        <li>
          <span>회사소개</span>
          <ul style="display: flex">
            <li
              v-for="(comp, idx) in items.comp"
              :key="`comp_${idx}`"
              @click="routeActive(comp.url)"
              @touchend="routeActive(comp.url)"
            >
              {{ comp.name }}
            </li>
          </ul>
        </li>

        <li>
          <span>사엽영역</span>
          <ul style="display: flex">
            <li
              v-for="(buns, idx) in items.buns"
              :key="`buns_${idx}`"
              @click="routeActive(buns.url)"
              @touchend="routeActive(buns.url)"
            >
              {{ buns.name }}
            </li>
          </ul>
        </li>
        <li>
          <span>주요실적</span>
          <ul style="display: flex">
            <li
              v-for="(perf, idx) in items.perf"
              :key="`perf_${idx}`"
              @click="routeActive(perf.url)"
              @touchend="routeActive(perf.url)"
            >
              {{ perf.name }}
            </li>
          </ul>
        </li>
        <li>
          <span>채용정보</span>
          <ul style="display: flex">
            <li
              v-for="(recr, idx) in items.recr"
              :key="`recr_${idx}`"
              @click="routeActive(recr.url)"
              @touchend="routeActive(recr.url)"
            >
              {{ recr.name }}
            </li>
          </ul>
        </li>
        <li>
          <span>고객센터</span>
          <ul style="display: flex">
            <li
              v-for="(info, idx) in items.info"
              :key="`info_${idx}`"
              @click="routeActive(info.url)"
              @touchend="routeActive(info.url)"
            >
              {{ info.name }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <img
      id="fullNavImg"
      src="../../../assets/image/ico/Logo-W.svg"
      alt="LogoImg"
    />
  </div>
</template>
<script>
import global from 'Mixins/global'

export default {
  mixins: [global],
  props: {
    isOn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // visible: this.isOn,
      isActive: this.isOn,
      //main title
      navTitle: [
        {
          name: '회사소개',
        },
        {
          name: '기업이념',
        },
        {
          name: '회사연혁',
        },
        {
          name: '조직도',
        },
        {
          name: '오시는길',
        },
      ],
      //sub title
      items: {
        comp: [
          {
            url: '/Comp-introduc',
            name: 'CEO인사말',
          },
          {
            url: '/Comp-introduc/Corp-ideology',
            name: '기업이념',
          },
          {
            url: '/Comp-introduc/History',
            name: '회사연혁',
          },
          {
            url: '/Comp-introduc/Organization-chart',
            name: '조직도',
          },
          {
            url: '/Comp-introduc/FindWay',
            name: '오시는길',
          },
        ],
        buns: [
          {
            url: '/business-area',
            name: '시설관리',
          },
          {
            url: '/business-area/logiMana',
            name: '물류관리',
          },
          {
            url: '/business-area/secuMana',
            name: '보안/주차관리',
          },
          {
            url: '/business-area/admiMana',
            name: '미화관리',
          },
          {
            url: '/business-area/hotelMana',
            name: '호텔 위탁운영',
          },
          // {
          //   url: '/business-area/faciMana',
          //   name: '종합관리(P.M)',
          // },
        ],
        perf: [
          {
            url: '/Performance',
            name: '호텔/리조트',
          },
          {
            url: '/Performance/Department-Store',
            name: '백화점/할인점',
          },
          {
            url: '',
            name: '자산관리',
          },
          {
            url: '/Performance/Distribution',
            name: '유통',
          },
          {
            url: '/Performance/perf-etc',
            name: '기타',
          },
        ],
        recr: [
          {
            url: '/Personnel',
            name: '채용정보',
          },
          // {
          //   url: '/Personnel',
          //   name: '채용정보',
          // },
          // {
          //   url: '',
          //   name: '입사지원안내',
          // },
        ],
        info: [
          {
            url: '/Customer-service',
            name: '뉴스&공지사항',
          },
          {
            url: '/Customer-service/Reference-room',
            name: '자료실',
          },
        ],
      },
    }
  },
  methods: {
    routeActive(Nm) {
      this.isActive = !this.isActive
      this.$router.push(Nm)
      this.$emit('routeActive')
    },
  },
  beforeDestroy() {
    const AllMenuWrap = document.querySelector('.AllMenu-wrap')
    if (this.isPc) {
      AllMenuWrap.removeEventListener('touchend', this.routeActive)
    } else {
      AllMenuWrap.removeEventListener('click', this.routeActive)
    }
  },
}
</script>
